const KEY = "sv_return_to";
let taken = null;

export const saveReturn = (path) => {
  if (path && path.startsWith("/") && !path.startsWith("//") && !path.startsWith("/login")) { sessionStorage.setItem(KEY, path); taken = null; }
};

export const takeReturn = () => {
  const p = sessionStorage.getItem(KEY) || taken;
  sessionStorage.removeItem(KEY);
  taken = p;
  setTimeout(() => { taken = null; }, 3000);
  return p && p.startsWith("/") && !p.startsWith("//") ? p : "/dashboard";
};
